export type ColorKeys =  | '@antPrefix' | '@pvPrefix' | '@colorsGray-1' | '@colorsGray-2' | '@colorsGray-3' | '@colorsGray-4' | '@colorsGray-5' | '@colorsGray-6' | '@colorsGray-7' | '@colorsGray-8' | '@colorsGray-9' | '@colorsGray-10' | '@colorsGreen-0' | '@colorsGreen-1' | '@colorsGreen-2' | '@colorsGreen-3' | '@colorsGreen-4' | '@colorsGreen-5' | '@colorsGreen-6' | '@colorsGreen-7' | '@colorsGreen-8' | '@colorsGreen-9' | '@colorsGreen-10' | '@screenLgMax' | '@screenLgMin' | '@screenLg' | '@screenMdMax' | '@screenMdMin' | '@screenMd' | '@screenSmMax' | '@screenSmMin' | '@screenSm' | '@screenXlMax' | '@screenXlMin' | '@screenXl' | '@screenXsMax' | '@screenXsMin' | '@screenXs' | '@screenXxlMax' | '@screenXxlMin' | '@screenXxl' | '@screenXxxlMin' | '@screenXxxl' | '@animationDurationBase' | '@animationDurationSlow' | '@animationDurationFast' | '@primaryColor' | '@successColor' | '@infoColor' | '@errorColor' | '@warningColor' | '@dangerColor' | '@accentColor' | '@white' | '@disabledColor' | '@fontFamilyPrimary' | '@fontFamilySecondary' | '@fontFamilyTertiary' | '@borderWidthBase' | '@borderStyleBase' | '@borderRadiusBase' | '@borderRadiusSm' | '@borderColorInverse' | '@borderColorBase' | '@borderColorFocused' | '@borderRadiusBase' | '@borderRadiusLg' | '@borderRadiusMd' | '@borderRadiusSm' | '@borderRadiusXs' | '@alertErrorBgColor' | '@alertMessageColor' | '@alertErrorBorderColor' | '@alertErrorIconColor' | '@alertErrorMessageColor' | '@alertInfoBgColor' | '@alertInfoBorderColor' | '@alertInfoIconColor' | '@alertInfoMessageColor' | '@alertSuccessBgColor' | '@alertSuccessBorderColor' | '@alertSuccessIconColor' | '@alertSuccessMessageColor' | '@alertWarningBgColor' | '@alertWarningBorderColor' | '@alertWarningIconColor' | '@alertWarningMessageColor' | '@alertWithDescriptionIconSize' | '@toastSuccessBg' | '@toastSuccessTitleColor' | '@toastSuccessMessageColor' | '@toastSuccessIconColor' | '@toastErrorBg' | '@toastErrorTitleColor' | '@toastErrorMessageColor' | '@toastErrorIconColor' | '@toastWarningBg' | '@toastWarningTitleColor' | '@toastWarningMessageColor' | '@toastWarningIconColor' | '@toastInfoBg' | '@toastInfoTitleColor' | '@toastInfoMessageColor' | '@toastInfoIconColor' | '@drawerBodyPadding' | '@drawerBg' | '@drawerHeaderCloseSize' | '@drawerHeaderCloseBg' | '@drawerHeaderCloseColor' | '@drawerHeaderCloseHoverColor' | '@drawerHeaderCloseHoverBg' | '@avatarBg' | '@avatarColor' | '@iconColor' | '@badgeCountBg' | '@badgeCountColor' | '@badgeColor' | '@badgeFontFamily' | '@badgeFontSize' | '@tagDefaultBg' | '@tagDefaultColor' | '@tagFontSize' | '@tagFontFamily' | '@tabsFontFamily' | '@tabsFontSize' | '@tabsActiveColor' | '@tabsBarColor' | '@backgroundColorBase' | '@bodyBackground' | '@layoutBodyBackground' | '@layoutFooterBackground' | '@layoutFooterHeight' | '@layoutFooterPadding' | '@layoutHeaderBackground' | '@layoutHeaderBorderColor' | '@layoutHeaderColor' | '@layoutHeaderHeight' | '@layoutHeaderMobileHeight' | '@layoutHeaderPadding' | '@layoutSectionPaddingHorizontal' | '@layoutSectionPaddingVertical' | '@layoutSectionPadding' | '@layoutSectionTitleFontFamily' | '@layoutSiderBackground' | '@layoutSiderWidth' | '@layoutSiderCollapsedWidth' | '@cartIconBg' | '@cartIconColor' | '@breadcrumbBaseColor' | '@breadcrumbFontSize' | '@breadcrumbFontFamily' | '@breadcrumbLastItemColor' | '@breadcrumbLinkColorHover' | '@breadcrumbLinkColor' | '@breadcrumbSeparatorColor' | '@btnFontFamily' | '@btnFontWeight' | '@btnTextTransform' | '@btnDefaultBg' | '@btnDefaultColor' | '@btnDefaultBorder' | '@btnDefaultDisabledColor' | '@btnDefaultHoverColor' | '@btnDefaultHoverBg' | '@btnDefaultHoverBorder' | '@btnGhostBg' | '@btnGhostBorder' | '@btnGhostColor' | '@btnGhostHoverBg' | '@btnGhostHoverColor' | '@btnGhostHoverBorder' | '@btnDisableBg' | '@btnDisableColor' | '@btnDisableBorder' | '@btnBorderRadius' | '@btnFontSizeLg' | '@btnFontWeight' | '@btnFontSize' | '@btnHeightBase' | '@btnHeightLg' | '@btnPrimaryBg' | '@btnPrimaryColor' | '@btnPrimaryBorderColor' | '@btnPrimaryHoverColor' | '@btnPrimaryHoverBg' | '@btnPrimaryHoverBorderColor' | '@btnSquareOnlyIconSize' | '@cardBg' | '@cardSelectedBg' | '@cardHoverableHoverBorder' | '@cardHoverableHoverShadow' | '@cardBadgeBg' | '@cardBadgeColor' | '@cardShadow' | '@cardSubtitleFontFamily' | '@cardMetaFontFamily' | '@cardBlurBgTransparency' | '@componentBackground' | '@componentColor' | '@collapseHeaderBg' | '@collapseHeaderColor' | '@collapseBodyBg' | '@collapseBodyColor' | '@datePickerBg' | '@datePickerHeadingColor' | '@datePickerCellColor' | '@fontWeightBase' | '@fontWeightStrong' | '@fontSizeBase' | '@fontSizeLg' | '@fontSizeSm' | '@heading-1Size' | '@heading-2Size' | '@heading-3Size' | '@heading-4Size' | '@heading-5Size' | '@headingFontWeight' | '@headingFontFamily' | '@headingColor' | '@headingSecondaryFontWeight' | '@headingSecondaryFontFamily' | '@headingSecondaryColor' | '@headingTransform' | '@pageHeaderHeadingFontFamily' | '@pageHeaderHeadingFontWeight' | '@pageHeaderHeadingTitle' | '@pageHeaderPaddingBreadcrumb' | '@pageHeaderPaddingVertical' | '@pageHeaderPadding' | '@pageHeaderBackColor' | '@textColorSecondary' | '@textColor' | '@textColorInverse' | '@textSelectionBg' | '@typographyTitleFontWeight' | '@linkColor' | '@linkHoverColor' | '@linkActiveColor' | '@linkDecoration' | '@linkHoverDecoration' | '@heightBase' | '@heightLg' | '@checkboxBorderWidth' | '@checkboxBg' | '@checkboxColor' | '@checkboxCheckBg' | '@checkboxCheckColor' | '@checkboxSize' | '@radioBorderWidth' | '@radioButtonBg' | '@radioButtonCheckedBg' | '@radioButtonColor' | '@radioDotColor' | '@radioSize' | '@formItemLabelFontSize' | '@inputColor' | '@inputLabelColor' | '@inputBg' | '@inputBorderColor' | '@inputBorderRadius' | '@inputDisabledBg' | '@inputDisabledColor' | '@inputHoverBorderColor' | '@inputIconColor' | '@inputNumberHandlerBg' | '@inputHeightSm' | '@inputHeightBase' | '@inputHeightLg' | '@labelColor' | '@calendarItemActiveBg' | '@menuCollapsedWidth' | '@menuDarkBg' | '@menuDarkColor' | '@menuDarkHighlightColor' | '@menuDarkItemActiveBg' | '@menuDarkSelectedItemIconColor' | '@menuDarkSelectedItemTextColor' | '@menuHighlightColor' | '@menuIconMarginRight' | '@menuIconSizeLg' | '@menuIconSize' | '@menuBg' | '@menuItemColor' | '@menuItemHoverBg' | '@menuItemHoverColor' | '@menuItemActiveBg' | '@menuItemActiveColor' | '@menuItemFontFamily' | '@menuItemFontSize' | '@menuItemFontWeight' | '@menuItemHeight' | '@menuItemPadding' | '@menuItemVerticalMargin' | '@menuItemTextTransform' | '@notificationWidth' | '@outlineBlurSize' | '@outlineWidth' | '@paginationItemSize' | '@pickerBasicCellActiveWithRangeColor' | '@pickerPanelCellHeight' | '@pickerPanelCellWidth' | '@popoverBg' | '@listItemMetaDescriptionFontSize' | '@listItemMetaTitleFontFamily' | '@listItemMetaTitleColor' | '@listItemMetaDescriptionFontFamily' | '@listItemMetaDescriptionColor' | '@pageHeaderBackColor' | '@tooltipArrowColor' | '@tooltipBg' | '@tooltipColor' | '@listItemBg' | '@listItemColor' | '@listItemHoverBg' | '@listItemHoverColor' | '@listItemActiveBg' | '@listItemActiveColor' | '@tableBg' | '@tableHeaderBg' | '@tableHeaderColor' | '@tableHeaderSelectedBg' | '@tableHeaderSelectedColor' | '@tableBorderColor' | '@tableExpandIconBg' | '@tableExpandIconColor' | '@tableRowBg' | '@tableRowColor' | '@tableRowHoverBg' | '@tableRowHoverColor' | '@modalBg' | '@modalCloseColor' | '@modalFooterBg'
export const DefaultTheme = {
  "@ant-prefix": "ant",
  "@pv-prefix": "pv",
  "@colors-gray-1": "rgb(255, 255, 255)",
  "@colors-gray-2": "rgb(248, 248, 248)",
  "@colors-gray-3": "rgb(207, 207, 211)",
  "@colors-gray-4": "rgb(183, 183, 189)",
  "@colors-gray-5": "rgb(159, 158, 166)",
  "@colors-gray-6": "rgb(134, 134, 144)",
  "@colors-gray-7": "rgb(110, 109, 121)",
  "@colors-gray-8": "rgb(85, 85, 94)",
  "@colors-gray-9": "rgb(59, 59, 64)",
  "@colors-gray-10": "rgb(33, 34, 36)",
  "@colors-green-0": "rgb(207, 239, 228)",
  "@colors-green-1": "rgb(206, 238, 227)",
  "@colors-green-2": "rgb(177, 216, 201)",
  "@colors-green-3": "rgb(148, 190, 174)",
  "@colors-green-4": "rgb(122, 164, 147)",
  "@colors-green-5": "rgb(87, 128, 110)",
  "@colors-green-6": "rgb(76, 118, 100)",
  "@colors-green-7": "rgb(56, 101, 81)",
  "@colors-green-8": "rgb(37, 84, 62)",
  "@colors-green-9": "rgb(21, 69, 47)",
  "@colors-green-10": "rgb(11, 57, 34)",
  "@screen-lg-max": "(@screen-xl - 1px)",
  "@screen-lg-min": "992px",
  "@screen-lg": "992px",
  "@screen-md-max": "(@screen-lg - 1px)",
  "@screen-md-min": "768px",
  "@screen-md": "768px",
  "@screen-sm-max": "(@screen-md - 1px)",
  "@screen-sm-min": "576px",
  "@screen-sm": "576px",
  "@screen-xl-max": "(@screen-xxl - 1px)",
  "@screen-xl-min": "1200px",
  "@screen-xl": "1200px",
  "@screen-xs-max": "(@screen-sm - 1px)",
  "@screen-xs-min": "375px - 1px",
  "@screen-xs": "375px",
  "@screen-xxl-max": "(@screen-xxxl - 1px)",
  "@screen-xxl-min": "1600px",
  "@screen-xxl": "1600px",
  "@screen-xxxl-min": "1920px",
  "@screen-xxxl": "1920px",
  "@animation-duration-base": "0.2s",
  "@animation-duration-slow": "0.3s",
  "@animation-duration-fast": "0.1s",
  "@primary-color": "#57806e",
  "@success-color": "#ceeee3",
  "@info-color": "#2db7f5",
  "@error-color": "#e06c51",
  "@warning-color": "#fce3a4",
  "@danger-color": "#d2381b",
  "@accent-color": "#fdf6e4",
  "@white": "#ffffff",
  "@disabled-color": "#cfcfd3",
  "@font-family-primary": "'Jost', sans-serif",
  "@font-family-secondary": "'Roboto', sans-serif",
  "@font-family-tertiary": "'Roboto', sans-serif",
  "@border-width-base": "1px",
  "@border-style-base": "solid",
  "@border-radius-base": "4px",
  "@border-radius-sm": "4px",
  "@border-color-inverse": "#ffffff",
  "@border-color-base": "#e8e7e9",
  "@border-color-focused": "#868690",
  "@border-radius-lg": "16px",
  "@border-radius-md": "8px",
  "@border-radius-xs": "2px",
  "@alert-error-bg-color": "var(--error-color)",
  "@alert-message-color": "var(--text-color)",
  "@alert-error-border-color": "var(--error-color)",
  "@alert-error-icon-color": "#ffffff",
  "@alert-error-message-color": "#ffffff",
  "@alert-info-bg-color": "#fff6e8",
  "@alert-info-border-color": "#fff6e8",
  "@alert-info-icon-color": "#cf8516",
  "@alert-info-message-color": "#cf8516",
  "@alert-success-bg-color": "rgb(206, 238, 227)",
  "@alert-success-border-color": "rgb(206, 238, 227)",
  "@alert-success-icon-color": "rgb(21, 69, 47)",
  "@alert-success-message-color": "rgb(21, 69, 47)",
  "@alert-warning-bg-color": "var(--warning-color)",
  "@alert-warning-border-color": "var(--warning-color)",
  "@alert-warning-icon-color": "var(--text-color-inverse)",
  "@alert-warning-message-color": "var(--text-color-inverse)",
  "@alert-with-description-icon-size": "24px",
  "@toast-success-bg": "rgb(206, 238, 227)",
  "@toast-success-title-color": "rgb(21, 69, 47)",
  "@toast-success-message-color": "rgb(21, 69, 47)",
  "@toast-success-icon-color": "rgb(21, 69, 47)",
  "@toast-error-bg": "var(--error-color)",
  "@toast-error-title-color": "#ffffff",
  "@toast-error-message-color": "#ffffff",
  "@toast-error-icon-color": "#ffffff",
  "@toast-warning-bg": "var(--warning-color)",
  "@toast-warning-title-color": "var(--text-color-inverse)",
  "@toast-warning-message-color": "var(--text-color-inverse)",
  "@toast-warning-icon-color": "var(--text-color-inverse)",
  "@toast-info-bg": "#fff6e8",
  "@toast-info-title-color": "#cf8516",
  "@toast-info-message-color": "#cf8516",
  "@toast-info-icon-color": "#cf8516",
  "@drawer-body-padding": "40px",
  "@drawer-bg": "var(--body-background)",
  "@drawer-header-close-size": "48px",
  "@drawer-header-close-bg": "#ffffff",
  "@drawer-header-close-color": "var(--text-color)",
  "@drawer-header-close-hover-color": "var(--text-color)",
  "@drawer-header-close-hover-bg": "#ffffff",
  "@avatar-bg": "var(--primary-color)",
  "@avatar-color": "var(--text-color)",
  "@icon-color": "inherit",
  "@badge-count-bg": "var(--primary-color)",
  "@badge-count-color": "var(--text-color-inverse)",
  "@badge-color": "var(--primary-color)",
  "@badge-font-family": "var(--font-family-primary)",
  "@badge-font-size": "14px",
  "@tag-default-bg": "#e7e9e8",
  "@tag-default-color": "var(--text-color-secondary)",
  "@tag-font-size": "12px",
  "@tag-font-family": "var(--font-family-primary)",
  "@tabs-font-family": "var(--font-family-secondary)",
  "@tabs-font-size": "var(--font-size-base)",
  "@tabs-active-color": "var(--primary-color)",
  "@tabs-bar-color": "#f0f0f0",
  "@background-color-base": "#ffffff",
  "@body-background": "#ffffff",
  "@layout-body-background": "#ffffff",
  "@layout-footer-background": "transparent",
  "@layout-footer-height": "112px",
  "@layout-footer-padding": "40px",
  "@layout-header-background": "transparent",
  "@layout-header-border-color": "#e8e7e9",
  "@layout-header-color": "var(--text-color)",
  "@layout-header-height": "112px",
  "@layout-header-mobile-height": "80px",
  "@layout-header-padding": "48px 40px 24px 40px",
  "@layout-section-padding-horizontal": "40px",
  "@layout-section-padding-vertical": "40px",
  "@layout-section-padding": "40px",
  "@layout-section-title-font-family": "var(--font-family-secondary)",
  "@layout-sider-background": "var(--text-color)",
  "@layout-sider-width": "280px",
  "@layout-sider-collapsed-width": "112px",
  "@cart-icon-bg": "#212224",
  "@cart-icon-color": "#ffffff",
  "@breadcrumb-base-color": "rgb(159, 158, 166)",
  "@breadcrumb-font-size": "12px",
  "@breadcrumb-font-family": "var(--font-family-secondary)",
  "@breadcrumb-last-item-color": "rgb(110, 109, 121)",
  "@breadcrumb-link-color-hover": "var(--text-color-secondary)",
  "@breadcrumb-link-color": "rgb(159, 158, 166)",
  "@breadcrumb-separator-color": "rgb(159, 158, 166)",
  "@btn-font-family": "var(--font-family-primary)",
  "@btn-font-weight": "700",
  "@btn-text-transform": "uppercase",
  "@btn-default-bg": "rgb(207, 207, 211)",
  "@btn-default-color": "var(--text-color-secondary)",
  "@btn-default-border": "rgb(207, 207, 211)",
  "@btn-default-disabled-color": "rgb(255, 255, 255)",
  "@btn-default-hover-color": "var(--text-color-secondary)",
  "@btn-default-hover-bg": "rgb(159, 158, 166)",
  "@btn-default-hover-border": "rgb(159, 158, 166)",
  "@btn-ghost-bg": "transparent",
  "@btn-ghost-border": "#e8e7e9",
  "@btn-ghost-color": "var(--text-color-secondary)",
  "@btn-ghost-hover-bg": "transparent",
  "@btn-ghost-hover-color": "var(--text-color-secondary)",
  "@btn-ghost-hover-border": "#e8e7e9",
  "@btn-disable-bg": "rgb(248, 248, 248)",
  "@btn-disable-color": "rgb(183, 183, 189)",
  "@btn-disable-border": "#e8e7e9",
  "@btn-border-radius": "4px",
  "@btn-font-size-lg": "14px",
  "@btn-font-size": "var(--font-size-base)",
  "@btn-height-base": "48px",
  "@btn-height-lg": "48px",
  "@btn-primary-bg": "var(--primary-color)",
  "@btn-primary-color": "#fff",
  "@btn-primary-border-color": "var(--btn-primary-bg)",
  "@btn-primary-hover-color": "#ffffff",
  "@btn-primary-hover-bg": "rgba(87, 128, 110, 0.85)",
  "@btn-primary-hover-border-color": "rgba(87, 128, 110, 0.85)",
  "@btn-square-only-icon-size": "16px",
  "@card-bg": "#fffdfa",
  "@card-selected-bg": "rgb(248, 248, 248)",
  "@card-hoverable-hover-border": "#e8e7e9",
  "@card-hoverable-hover-shadow": "0px 0px 31px rgba(0, 0, 0, 0.06)",
  "@card-badge-bg": "var(--primary-color)",
  "@card-badge-color": "var(--text-color-inverse)",
  "@card-shadow": "0 0 1px rgb(207, 207, 211)",
  "@card-subtitle-font-family": "var(--font-family-secondary)",
  "@card-meta-font-family": "var(--font-family-secondary)",
  "@card-blur-bg-transparency": "0.75",
  "@component-background": "#ffffff",
  "@component-color": "var(--text-color-secondary)",
  "@collapse-header-bg": "var(--card-bg)",
  "@collapse-header-color": "var(--text-color)",
  "@collapse-body-bg": "#ffffff",
  "@collapse-body-color": "var(--text-color)",
  "@date-picker-bg": "var(--input-bg)",
  "@date-picker-heading-color": "var(--text-color-secondary)",
  "@date-picker-cell-color": "var(--text-color)",
  "@font-weight-base": "400",
  "@font-weight-strong": "700",
  "@font-size-base": "14px",
  "@font-size-lg": "14px",
  "@font-size-sm": "12px",
  "@heading-1-size": "36px",
  "@heading-2-size": "28px",
  "@heading-3-size": "22px",
  "@heading-4-size": "20px",
  "@heading-5-size": "16px",
  "@heading-font-weight": "800",
  "@heading-font-family": "var(--font-family-primary)",
  "@heading-color": "var(--text-color)",
  "@heading-secondary-font-weight": "600",
  "@heading-secondary-font-family": "var(--font-family-secondary)",
  "@heading-secondary-color": "var(--text-color)",
  "@heading-transform": "uppercase",
  "@page-header-heading-font-family": "var(--font-family-primary)",
  "@page-header-heading-font-weight": "900",
  "@page-header-heading-title": "36px",
  "@page-header-padding-breadcrumb": "0",
  "@page-header-padding-vertical": "0",
  "@page-header-padding": "0",
  "@page-header-back-color": "#000",
  "@text-color-secondary": "#6e6d79",
  "@text-color": "#212224",
  "@text-color-inverse": "#ffffff",
  "@text-selection-bg": "var(--text-color)",
  "@typography-title-font-weight": "800",
  "@link-color": "var(--primary-color)",
  "@link-hover-color": "var(--accent-color)",
  "@link-active-color": "rgba(var(--primary-color), 0.85)",
  "@link-decoration": "none",
  "@link-hover-decoration": "none",
  "@height-base": "48px",
  "@height-lg": "48px",
  "@checkbox-border-width": "1px",
  "@checkbox-bg": "var(--input-bg)",
  "@checkbox-color": "var(--text-color)",
  "@checkbox-check-bg": "var(--text-color)",
  "@checkbox-check-color": "var(--text-color-inverse)",
  "@checkbox-size": "16px",
  "@radio-border-width": "1px",
  "@radio-button-bg": "var(--text-color-inverse)",
  "@radio-button-checked-bg": "var(--text-color-inverse)",
  "@radio-button-color": "var(--text-color-inverse)",
  "@radio-dot-color": "#212224",
  "@radio-size": "16px",
  "@form-item-label-font-size": "12px",
  "@input-color": "var(--text-color)",
  "@input-label-color": "var(--input-color)",
  "@input-bg": "#ffffff",
  "@input-border-color": "#e8e7e9",
  "@input-border-radius": "4px",
  "@input-disabled-bg": "#f8f8f8",
  "@input-disabled-color": "var(--input-color)",
  "@input-hover-border-color": "rgb(85, 85, 94)",
  "@input-icon-color": "var(--text-color)",
  "@input-number-handler-bg": "#ffffff",
  "@input-height-sm": "36px",
  "@input-height-base": "48px",
  "@input-height-lg": "48px",
  "@label-color": "var(--text-color-secondary)",
  "@calendar-item-active-bg": "#57806e",
  "@menu-collapsed-width": "112px",
  "@menu-dark-bg": "transparent",
  "@menu-dark-color": "var(--text-color-inverse)",
  "@menu-dark-highlight-color": "var(--menu-highlight-color)",
  "@menu-dark-item-active-bg": "transparent",
  "@menu-dark-selected-item-icon-color": "var(--menu-highlight-color)",
  "@menu-dark-selected-item-text-color": "var(--text-color-inverse)",
  "@menu-highlight-color": "var(--primary-color)",
  "@menu-icon-margin-right": "16px",
  "@menu-icon-size-lg": "24px",
  "@menu-icon-size": "16px",
  "@menu-bg": "var(--text-color)",
  "@menu-item-color": "var(--text-color-inverse)",
  "@menu-item-hover-bg": "transparent",
  "@menu-item-hover-color": "var(--primary-color)",
  "@menu-item-active-bg": "var(--primary-color)",
  "@menu-item-active-color": "var(--text-color-inverse)",
  "@menu-item-font-family": "var(--font-family-primary)",
  "@menu-item-font-size": "15px",
  "@menu-item-font-weight": "700",
  "@menu-item-height": "48px",
  "@menu-item-padding": "48px / 2 40px",
  "@menu-item-vertical-margin": "8px",
  "@menu-item-text-transform": "uppercase",
  "@notification-width": "420px",
  "@outline-blur-size": "0",
  "@outline-width": "0",
  "@pagination-item-size": "36px",
  "@picker-basic-cell-active-with-range-color": "rgba(206, 238, 227, 0.3)",
  "@picker-panel-cell-height": "40px",
  "@picker-panel-cell-width": "40px",
  "@popover-bg": "#ffffff",
  "@list-item-meta-description-font-size": "1em",
  "@list-item-meta-title-font-family": "var(--font-family-secondary)",
  "@list-item-meta-title-color": "var(--text-color-secondary)",
  "@list-item-meta-description-font-family": "var(--font-family-secondary)",
  "@list-item-meta-description-color": "var(--text-color-secondary)",
  "@tooltip-arrow-color": "var(--primary-color)",
  "@tooltip-bg": "var(--primary-color)",
  "@tooltip-color": "#ffffff",
  "@list-item-bg": "#ffffff",
  "@list-item-color": "var(--text-color)",
  "@list-item-hover-bg": "#f0f0f0",
  "@list-item-hover-color": "var(--text-color)",
  "@list-item-active-bg": "#e9e9e9",
  "@list-item-active-color": "var(--text-color)",
  "@table-bg": "var(--component-background)",
  "@table-header-bg": "#f8f8f8",
  "@table-header-color": "var(--text-color)",
  "@table-header-selected-bg": "#e4e4e4",
  "@table-header-selected-color": "var(--text-color)",
  "@table-border-color": "#e8e7e9",
  "@table-expand-icon-bg": "rgb(207, 207, 211)",
  "@table-expand-icon-color": "white",
  "@table-row-bg": "var(--body-background)",
  "@table-row-color": "var(--text-color)",
  "@table-row-hover-bg": "rgb(248, 248, 248)",
  "@table-row-hover-color": "var(--text-color)",
  "@modal-bg": "#ffffff",
  "@modal-close-color": "#212224",
  "@modal-footer-bg": "#ffffff"
}